// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__lpFCB","label":"LabeledBox_label__3HrO0"};